const lib = {};
lib['reaction'] = {}
import reactiongeneral from './reaction/general';
lib['reaction']['general'] = reactiongeneral;

lib['sample'] = {}
import samplechromatogram from './sample/chromatogram';
lib['sample']['chromatogram'] = samplechromatogram;

import samplecyclicVoltammetry from './sample/cyclicVoltammetry';
lib['sample']['cyclicVoltammetry'] = samplecyclicVoltammetry;

import sampledifferentialCentrifugalSedimentation from './sample/differentialCentrifugalSedimentation';
lib['sample']['differentialCentrifugalSedimentation'] = sampledifferentialCentrifugalSedimentation;

import sampledifferentialScanningCalorimetry from './sample/differentialScanningCalorimetry';
lib['sample']['differentialScanningCalorimetry'] = sampledifferentialScanningCalorimetry;

import sampleelementAnalysis from './sample/elementAnalysis';
lib['sample']['elementAnalysis'] = sampleelementAnalysis;

import samplegenbank from './sample/genbank';
lib['sample']['genbank'] = samplegenbank;

import samplegeneral from './sample/general';
lib['sample']['general'] = samplegeneral;

import samplehgPorosimetry from './sample/hgPorosimetry';
lib['sample']['hgPorosimetry'] = samplehgPorosimetry;

import sampleimage from './sample/image';
lib['sample']['image'] = sampleimage;

import sampleir from './sample/ir';
lib['sample']['ir'] = sampleir;

import sampleisotherm from './sample/isotherm';
lib['sample']['isotherm'] = sampleisotherm;

import sampleiv from './sample/iv';
lib['sample']['iv'] = sampleiv;

import samplemass from './sample/mass';
lib['sample']['mass'] = samplemass;

import samplenmr from './sample/nmr';
lib['sample']['nmr'] = samplenmr;

import sampleoan from './sample/oan';
lib['sample']['oan'] = sampleoan;

import samplephysical from './sample/physical';
lib['sample']['physical'] = samplephysical;

import sampleraman from './sample/raman';
lib['sample']['raman'] = sampleraman;

import samplethermogravimetricAnalysis from './sample/thermogravimetricAnalysis';
lib['sample']['thermogravimetricAnalysis'] = samplethermogravimetricAnalysis;

import sampleuv from './sample/uv';
lib['sample']['uv'] = sampleuv;

import samplevideo from './sample/video';
lib['sample']['video'] = samplevideo;

import samplexps from './sample/xps';
lib['sample']['xps'] = samplexps;

import samplexray from './sample/xray';
lib['sample']['xray'] = samplexray;

import samplexrd from './sample/xrd';
lib['sample']['xrd'] = samplexrd;

import samplexrf from './sample/xrf';
lib['sample']['xrf'] = samplexrf;

export default lib;